import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class DeviceCommandSchedulerService {
  url: string = environment.commandScheduler;

  constructor(
    private httpClient: HttpClient) { }

    async getRequests(count: number, paginationToken: string): Promise<CommandRequestResponse> {
        return await this.httpClient.get<CommandRequestResponse>(`${this.url}/devices/commandStatus?count=${count}&paginationToken=${paginationToken}`).toPromise();
    }

    async submitCommandRequest(commandRequest: CommandRequest): Promise<void> {
        return await this.httpClient.post<void>(`${this.url}/devices/commandExecution`, commandRequest).toPromise();
    }
}

export interface CommandRequestResponse{
    commandRequests: CommandRequestRecord[],
    paginationToken: string,
    endOfSet: boolean
}

export interface CommandRequestRecord{
    commandRequestId: string,
    command: string,
    status: string,
    deviceCount: number,
    requesterName: string,
    description: string,
    requestedDate: string,
    inProgress: string[],
    complete: string[],
    error: string[],
}

export interface CommandRequest{
    command: string,
    serialNumbers: string[],
    requesterName: string,
    description: string,
}

